import { Dropdown } from "react-bootstrap";
import { PersonFill, List } from "react-bootstrap-icons";
import { useNavigate } from "react-router";
import { User } from "../models/User";
import { navigateAdvisory } from "../util/utils";
import { useProfile } from "./ProfileContext";

export function ProfileNavDropDown(props) {
	let { showFullName, ...passableProps } = props;
	let navigate = useNavigate();
	let [profile, setProfile] = useProfile();
    let logoutAction = () => {
		if(confirm("Are you sure you want to log out?")) {
			setProfile(null);
			User.saveUser(null);
			navigate("/login")
		}
	};
	return <Dropdown {...passableProps}>
		<Dropdown.Toggle variant="success"><List style={{width:'2em', height:'2em'}} /> {showFullName && profile.fullName}</Dropdown.Toggle>
		<Dropdown.Menu>
			<Dropdown.Item disabled={true}>{profile.fullName}</Dropdown.Item>
			<Dropdown.Item disabled={true}>({profile.userName})</Dropdown.Item>
			<Dropdown.Divider />
			<Dropdown.Item onClick={() => navigateAdvisory(navigate, "/dashboard")}>Dashboard</Dropdown.Item>
			<Dropdown.Divider />
			<Dropdown.Item onClick={() => navigateAdvisory(navigate, "/inspections")}>Inspections</Dropdown.Item>
			<Dropdown.Item onClick={() => navigateAdvisory(navigate, "/assets")}>Assets</Dropdown.Item>
			<Dropdown.Item onClick={() => navigateAdvisory(navigate, "/assets/search")}>Asset Search</Dropdown.Item>
			<Dropdown.Item onClick={() => navigateAdvisory(navigate, "/parts")}>Parts</Dropdown.Item>
			<Dropdown.Divider />
			<Dropdown.Item onClick={() => navigateAdvisory(navigate, "/jobs")}>Jobs</Dropdown.Item>
			<Dropdown.Item onClick={() => navigateAdvisory(navigate, "/settings")}>Settings</Dropdown.Item>
			<Dropdown.Item onClick={() => navigateAdvisory(navigate, "/admin")}>Admin</Dropdown.Item>
			{false && <Dropdown.Item onClick={() => navigateAdvisory(navigate, "/debug")}>Debug</Dropdown.Item>}
			<Dropdown.Divider />
			<Dropdown.Item onClick={logoutAction}>Logout</Dropdown.Item>
		</Dropdown.Menu>
	</Dropdown>;
}